import React from 'react';
import logo from '../assets/africanenda-logo.png';

/**
 * The AfricaNenda Foundation wordmark. Designed for light backgrounds
 * (the mark's text is dark). Size it with a Tailwind height class, e.g. `h-9`.
 */
export default function AfricaNendaLogo({ className = 'h-9' }) {
  return <img src={logo} alt="AfricaNenda Foundation" className={`w-auto ${className}`} />;
}
